import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();

export const woocommerceRoutes = [
	{
		path: '/',
		redirect: '/shop'
	},
	{
		path: '/shop',
		name: 'woocommerce.shop',
		meta: { title: t('shop_page') },
		component: () => import('@/woocommerce/ShopPage.vue'),
	},
	{
		path: '/product',
		name: 'woocommerce.product',
		meta: { title: t('product_page') },
		component: () => import('@/woocommerce/ProductPage.vue'),
	},
	{
		path: '/cart',
		name: 'woocommerce.cart',
		meta: { title: t('cart_page') },
		component: () => import('@/woocommerce/CartPage.vue'),
	},
	{
		path: '/checkout',
		name: 'woocommerce.checkout',
		meta: { title: t('checkout_page') },
		component: () => import('@/woocommerce/CheckoutPage.vue'),
	},
]
